<template>
  <div style="text-align: center;">
    <y-shelf title="邀约设计师">
      <div slot="content" class="desHeader">
        <div style="height: 600px;">
          <div class="transfer">
            <el-row :gutter="0" class="condition-table">
              <!-- 左侧 -->
              <el-col :span="10" style="padding-left:0">
                <div class="no-add">
                  <span>候选列表</span>
                </div>
                <div style="width: 100%;height: 40px;">
                  <el-input class="el-transfer-panel__filter" v-model="queryLeftParam.nickName"
                            size="small" placeholder="请输入设计师名称">
                    <i slot="prefix" class="el-icon-search search-position"></i>
                  </el-input>
                </div>
                <el-table ref="staffTable" border v-loading="loading"
                          style="height: 500px;overflow-y: auto;"
                          :row-key="getRowKeyLeft" :data="leftDesList"
                          @selection-change="handleStaffChange"
                          :header-cell-style="{ background: '#f5f8ff' }">
                  <el-table-column type="selection" align="center" :reserve-selection="true"
                                   width="55"></el-table-column>
                  <el-table-column label="编号" align="center" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                      <span>{{ row.userCode }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="名称" align="center" show-overflow-tooltip>
                    <template slot-scope="{row}">
                      <span>{{ row.nickName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" show-overflow-tooltip>
                    <template slot-scope="{row}">
                      <el-button @click="addItemToRightList({ row })">添加</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="table-footer">
                  <el-pagination @current-change="leftPageNum" :pager-count="5"
                                 :current-page.sync="queryLeftParam.pageNum"
                                 :page-size="queryLeftParam.pageSize" layout="prev, pager, next"
                                 :total="leftTotal" style="margin-top: 1%;">
                  </el-pagination>
                </div>
              </el-col>
              <!-- 多选移动箭头图标 -->
              <div class="icon-center">
                <p class="icon-right-if icon-return" @click="batchAddToRightList()"
                   v-if="selectLeftData.length > 0">
                  <i class="el-icon-arrow-left"></i>
                </p>
                <p class="icon-right-else icon-return" v-else>
                  <i class="el-icon-arrow-left"></i>
                </p>
                <p class="icon-right-if" @click="removeStaff()"
                   v-if="selectRightData.length > 0">
                  <i class="el-icon-arrow-left"></i>
                </p>
                <p class="icon-right-else" v-else>
                  <i class="el-icon-arrow-left"></i>
                </p>
              </div>
              <!-- 右侧 -->
              <el-col :span="10" style="padding-right:0">
                <div class="no-add">
                  <span>邀约列表</span>
                </div>
                <div style="width:100%;height: 40px;">
                  <el-input class="el-transfer-panel__filter" v-model="queryRightParam.nickName"
                            size="small" placeholder="请输入设计师名称">
                    <i slot="prefix" class="el-icon-search search-position"></i>
                  </el-input>
                </div>
                <el-table ref="selectedStaffTable" border v-loading="loading"
                          :row-key="getRowKeyRight" :data="rightDesList"
                          @selection-change="handleSelectedStaffChange"
                          :header-cell-style="{ background: '#f5f8ff' }"
                          style="height: 500px;overflow-y: auto;">
                  <el-table-column type="selection" align="center" :reserve-selection="true"
                                   width="55"></el-table-column>
                  <el-table-column label="编号" align="center" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                      <span>{{ row.userCode }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="名称" align="center" show-overflow-tooltip>
                    <template slot-scope="{row}">
                      <span>{{ row.nickName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="服务单类型" align="center" show-overflow-tooltip>
                    <template slot-scope="{row}">
                      <span>{{ getServCataNames(row.servCataId) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" show-overflow-tooltip>
                    <template slot-scope="{row}">
                      <el-button @click="addItemToLeftList({ row })">移除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="table-footer">
                  <el-button class="handle-btn" type="primary" plain size="mini"
                             @click="handleSubmit">保存
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </y-shelf>
    <el-dialog
      :visible.sync="dialogFlag"
      width="600px"
      center
      title='添加服务单类型'
      class="order-dialog">
      <div class="order-content">
        <div class="search-item" style="display: flex;justify-content: center;align-items: center;margin: 25px 0">
          选择服务单类型&#xff1a;<el-cascader v-model="queryParams.servCataId" :options="common.category"
                                             :props="optionProps"
                                             :show-all-levels="false" :popper-append-to-body="false"
                                             popper-class="order-cascader-popper"
                                             placeholder="请选择服务单类型" @change="changeServCataId"
                                             >
        </el-cascader>
        </div>
      </div>
      <!-- 底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFlag = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import YShelf from '/components/YShelf';
import {mapState} from "vuex";

export default {
  data() {
    return {
      queryRightParam: {
        nickName: '',
      },
      queryLeftParam: {
        pageNum: 1,
        pageSize: 30,
        nickName: '',
      },
      unChangeLeft: [],//获取后的左侧列表数据
      unChangeRight: [],//获取后的右侧列表数据
      leftDesList: [],//左边表格数据
      rightDesList: [], //右边表格数据
      selectLeftData: [],//左边选中列表
      selectRightData: [],//右边选中列表
      loading: false,
      dialogFlag: false,
      leftTotal: 0,
      leftList: [],//没有分页检索的全部des数据
      rightList: [],//筛选前右列表
      userId: '',//右侧列表当前用户id
      blockDesList: [],//拉黑列表数据
      inviteDesList: [],//邀约列表数据
      queryParams: {
        servCataId: [],
        row: []
      },
      optionProps: {
        value: 'servId',
        label: 'servName',
        children: 'children',
        expandTrigger: 'hover',
        multiple: true,
      },
    };
  },
  methods: {
    //右侧列表检索过滤
    filterRightParam() {
      if (this.queryRightParam.nickName != '') {
        const keyword = this.queryRightParam.nickName;
        this.rightDesList = this.rightList.filter(item => {
          return (item.nickName && item.nickName.includes(keyword)) ||
            (item.userCode && item.userCode.toString().includes(keyword));
        });
      } else {
        this.rightDesList = this.rightList;
      }
    },
    //左侧列表检索过滤
    filterLeftParam() {
      const keyword = this.queryLeftParam.nickName;
      if (keyword && keyword.trim() !== '') {
        const searchKey = keyword.trim();
        this.leftDesList = this.leftList.filter(item => {
          return (item.nickName && item.nickName.includes(searchKey)) ||
            (item.userCode && item.userCode.toString().includes(searchKey));
        }).map(item => {
          return { ...item, nickName: this.showName(item.nickName) };
        });
        this.leftTotal = this.leftDesList.length;
      } else {
        this.leftDesList = this.leftList.map(item => {
          return { ...item, nickName: this.showName(item.nickName) };
        });
        this.leftTotal = this.leftDesList.length;
      }
    },
    // 获取左侧列表数据（参考blockDesList顺序链式调用）
    loadLeftList() {
      this.$api.post({
        url: `/user/desUserList?pageSize=9999`
      }).then(res => {
        this.loadBlocDeskList().catch(() => {}).then(() => {
          const blockSet = new Set(this.blockDesList.map(id => String(id)));
          // 保存全部数据供本地搜索过滤，仅排除拉黑的设计师
          this.leftList = res.rows.filter(item => {
            return !blockSet.has(String(item.userId));
          });
          // 分页显示
          const start = (this.queryLeftParam.pageNum - 1) * this.queryLeftParam.pageSize;
          const end = start + this.queryLeftParam.pageSize;
          this.leftTotal = this.leftList.length;
          this.leftDesList = this.leftList.slice(start, end).map(item => {
            return { ...item, nickName: this.showName(item.nickName) };
          });
          this.unChangeLeft = [...this.leftDesList];
        })
      }).catch(() => {
        this.leftDesList = [];
        this.leftTotal = 0;
      })
    },
    // 右侧列表获取数据（兼容tempData新格式和旧格式，一次API调用统一处理）
    loadRightList() {
      this.rightDesList = [];
      this.$api.get({ url: '/biz/inviteDes/list' }).then(res => {
        if (!(res.data && res.data.length > 0)) {
          this.rightList = [];
          this.unChangeRight = [];
          return;
        }
        this.userId = res.data[0].id;
        // 提取设计师ID列表（兼容新旧格式）
        let desItems = []; // {desUserId, servCataId}
        const d = res.data[0];
        if (d.tempData && d.tempData.length > 0) {
          const tempData = typeof d.tempData === 'string' ? JSON.parse(d.tempData) : d.tempData;
          desItems = tempData;
          this.inviteDesList = desItems.map(item => String(item.desUserId));
        } else if (d.desUserId !== undefined || d.desUserCode !== undefined) {
          // 旧格式1：res.data是设计师记录数组，直接字段映射（与blockDesList.vue一致）
          this.rightDesList = res.data.map(item => ({
            userId: item.desUserId,
            userCode: item.desUserCode,
            nickName: item.desUserName,
            servCataId: Array.isArray(item.servCataIds)
              ? item.servCataIds.join(',') : (item.servCataIds || ''),
            id: item.id,
          }));
          this.inviteDesList = this.rightDesList.map(item => String(item.userId));
          this.rightList = [...this.rightDesList];
          this.unChangeRight = [...this.rightDesList];
          return;
        } else {
          // 旧格式2：单条记录含逗号分隔的ID字符串
          const ids = (d.desUserIds || d.desUserId || '').split(',').filter(Boolean);
          this.inviteDesList = ids;
          desItems = ids.map(id => ({ desUserId: id, servCataId: '' }));
        }
        if (desItems.length === 0) return;
        // 一次性获取全部设计师列表，用Map做O(1)匹配
        this.$api.post({ url: `/user/desUserList?pageSize=9999` }).then(des => {
          const desMap = new Map();
          des.rows.forEach(item => desMap.set(String(item.userId), item));
          desItems.forEach(td => {
            const matched = desMap.get(String(td.desUserId));
            if (matched) {
              this.rightDesList.push({
                ...matched,
                nickName: this.showName(matched.nickName),
                servCataId: td.servCataId || '',
              });
            }
          });
          this.rightList = [...this.rightDesList];
          this.unChangeRight = [...this.rightDesList];
        });
      }).catch(() => {});
    },
    // 获取拉黑的设计师列表（兼容tempData新格式和旧格式）
    loadBlocDeskList() {
      return this.$api.get({ url: '/biz/blockDes/list' }).then(res => {
        this.blockDesList = [];
        if (!(res.data && res.data.length > 0)) return;
        const d = res.data[0];
        if (d.tempData && d.tempData.length > 0) {
          // tempData可能是JSON字符串，需先解析
          const tempData = typeof d.tempData === 'string' ? JSON.parse(d.tempData) : d.tempData;
          if (tempData.length > 0) {
            this.blockDesList = tempData.map(item => String(item.desUserId));
          }
        } else if (d.desUserId !== undefined || d.desUserCode !== undefined) {
          // 旧格式1：res.data是设计师记录数组（与blockDesList.vue一致）
          this.blockDesList = res.data.map(item => String(item.desUserId || item.userId));
        } else {
          // 旧格式2：单条记录含逗号分隔的ID字符串
          const ids = d.desUserIds || d.desUserId || d.userIds || '';
          this.blockDesList = ids ? String(ids).split(',') : [];
        }
      });
    },
    // 获取邀约列表（若loadRightList已提取则直接返回，避免重复请求）
    loadInviteList() {
      if (this.inviteDesList.length > 0) return Promise.resolve();
      return this.$api.get({ url: '/biz/inviteDes/list' }).then(res => {
        this.inviteDesList = [];
        if (!(res.data && res.data.length > 0)) return;
        const d = res.data[0];
        if (d.tempData && d.tempData.length > 0) {
          const tempData = typeof d.tempData === 'string' ? JSON.parse(d.tempData) : d.tempData;
          if (tempData.length > 0) {
            this.inviteDesList = tempData.map(item => String(item.desUserId));
          }
        } else {
          const ids = d.desUserIds || d.desUserId || '';
          this.inviteDesList = ids ? ids.split(',') : [];
        }
      }).catch(() => {});
    },
    // 行数据的Key
    getRowKeyLeft(row) {
      return row.id;
    },
    getRowKeyRight(row) {
      return row.id;
    },
    // 左侧列表当前页数
    leftPageNum(current) {
      this.queryLeftParam.pageNum = current;
      this.loadLeftList();
    },
    // 将左边表格选择项存入selectLeftData中(后面与右边的对比，右边已存在再不添加)
    handleStaffChange(rows) {
      this.selectLeftData = [];
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.selectLeftData.push(row);
          }
        });
      }
    },
    // 左边表格选择项移到右边
    addStaff() {
      setTimeout(() => {
        if (this.$refs["staffTable"]) {
          this.$refs["staffTable"].clearSelection();
        }
        if (this.$refs["selectedStaffTable"]) {
          this.$refs["selectedStaffTable"].clearSelection();
        }
      }, 0);
      // 以 userId 为唯一标识，已存在的设计师合并服务单类型
      const existingMap = new Map();
      this.rightDesList.forEach((item, index) => {
        existingMap.set(item.userId, index);
      });
      const toAdd = [];
      const duplicates = [];
      this.selectLeftData.forEach(item => {
        if (existingMap.has(item.userId)) {
          // 已存在，合并服务单类型（去重）
          const existing = this.rightDesList[existingMap.get(item.userId)];
          const oldIds = (existing.servCataId || '').split(',').filter(Boolean);
          const newIds = (item.servCataId || '').split(',').filter(Boolean);
          const merged = [...new Set([...oldIds, ...newIds])].join(',');
          existing.servCataId = merged;
          // 同步 unChangeRight
          const unChangeItem = this.unChangeRight.find(u => u.userId === item.userId);
          if (unChangeItem) unChangeItem.servCataId = merged;
          duplicates.push(item.nickName || item.userId);
        } else {
          toAdd.push(item);
          existingMap.set(item.userId, this.rightDesList.length + toAdd.length - 1);
        }
      });
      if (duplicates.length) {
        this.$message.warning(`设计师「${[...new Set(duplicates)].join('、')}」已存在，已合并服务单类型`);
      }
      // 添加新设计师到右侧列表
      toAdd.forEach(item => {
        this.rightDesList.push(item);
        this.unChangeRight.push(item);
      });
      this.rightList = this.rightDesList;
      this.leftTotal = this.leftList.length;
      this.leftDesList = [...this.unChangeLeft];
      this.queryLeftParam.nickName = '';
    },
    // 右边表格选择项移到左边
    removeStaff() {
      setTimeout(() => {
        if (this.$refs["staffTable"]) {
          this.$refs["staffTable"].clearSelection();
        }
        if (this.$refs["selectedStaffTable"]) {
          this.$refs["selectedStaffTable"].clearSelection();
        }
      }, 0);
      // 右侧列表移除(筛选过滤后的)
      for (let i = 0; i < this.unChangeRight.length; i++) {
        for (let j = 0; j < this.selectRightData.length; j++) {
          if (this.unChangeRight[i] && this.selectRightData[j] && this.unChangeRight[i].userId === this.selectRightData[j].userId) {
            this.unChangeRight.splice(i, 1);
          }
        }
      }
      // this.leftList = this.leftDesList;
      this.rightDesList = [...this.unChangeRight];
      this.queryRightParam.nickName = '';
    },
    // 将右边表格选择项存入selectRightData中
    handleSelectedStaffChange(rows) {
      this.selectRightData = [];
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.selectRightData.push(row);
          }
        });
      }
    },
    // 按钮保存提交
    handleSubmit() {
      // 修改右侧列表,重新获取列表数据
      let tempData = [];
      for (let i = 0; i < this.rightDesList.length; i++) {
        let desUserId = this.rightDesList[i].userId;
        let servCataId = this.rightDesList[i].servCataId;
        tempData.push({servCataId, desUserId});
      }
      this.$api.post({
        url: '/biz/inviteDes/save',
        data: {
          id: this.userId,
          tempData: tempData
        }
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.loadRightList();
          this.loadLeftList();
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 单项添加到左对列表
    addItemToLeftList(row) {
      this.selectRightData = [];
      this.selectRightData.push(row.row);
      this.removeStaff();
      this.$nextTick(() => {
        this.selectRightData = [];
      })
    },
    // 批量添加到右列表
    batchAddToRightList() {
      this.dialogFlag = true;
      this.queryParams.servCataId = [];
      this.queryParams.row = [...this.selectLeftData];
    },
    // 单项添加到右列表
    addItemToRightList(row) {
      this.dialogFlag = true;
      this.queryParams.servCataId = [];
      this.queryParams.row = row.row;
    },
    submitForm() {
      const val = this.queryParams.servCataId;
      // 提取叶子节点ID并去重，用逗号拼接
      const servCataIds = Array.isArray(val) && val.length > 0
        ? [...new Set(val.map(path => path[path.length - 1]))]
        : [];
      if (servCataIds.length === 0) {
        this.$message.warning('请先选择服务单类型');
        return;
      }
      const {row} = this.queryParams;
      const rows = Array.isArray(row) ? row : [row];
      // 设计师按userId去重
      const uniqueRows = [];
      const seenUserIds = new Set();
      rows.forEach(item => {
        if (!seenUserIds.has(item.userId)) {
          seenUserIds.add(item.userId);
          uniqueRows.push(item);
        }
      });
      // 每个设计师一条记录，多个服务单类型用逗号拼接
      const servCataStr = servCataIds.join(',');
      this.selectLeftData = uniqueRows.map(item => ({...item, servCataId: servCataStr}));
      this.addStaff();
      this.dialogFlag = false;
      this.$nextTick(() => {
        this.selectLeftData = [];
      })
    },
    changeServCataId() {
    },
    getServCataNames(ids) {
      if (!ids || !this.common.category || this.common.category.length === 0) return '';
      const idArr = ids.split(',').filter(Boolean);
      const findName = (list, id) => {
        for (const item of list) {
          if (String(item.servId) === String(id)) return item.servName;
          if (item.children) {
            const found = findName(item.children, id);
            if (found) return found;
          }
        }
        return null;
      };
      const names = idArr.map(id => findName(this.common.category, id)).filter(Boolean);
      return names.join('、');
    },
    showName(name) {
      let value = '';
      if (name.length <= 2) {
        value = name.substring(0, 1) + '*';
      } else {
        value = name.substring(0, 1) + '**';
      }
      return value;
    }
  },
  computed: {
    ...mapState(['common', 'user']),
  },
  watch: {
    'queryLeftParam.nickName'() {
      this.filterLeftParam();
    },
    'queryRightParam.nickName'() {
      this.filterRightParam();
    }
  },
  created() {
    this.loading = true;
    this.loadLeftList();
    this.loadRightList();
    this.loading = false;
  },
  components: {
    YShelf,
  }
}
</script>
<style lang="scss" scoped>
.transfer-footer {
  margin-left: 15px;
  padding: 6px 5px;
}

.desHeader {
  height: 700px;
}

.transfer {
  width: auto;
  padding: 30px;

  .condition-table {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .el-icon-arrow-left {
    font-size: 21px !important;
    background: #d9d9d9;
    border-radius: 4px;
    color: #fff;
    padding: 2px;
  }

  /deep/ .el-popover__reference-wrapper {
    vertical-align: middle !important;
    padding-left: 4px;
  }

  .icon-right-if .el-icon-arrow-left {
    background: #409eff;
    color: #fff;
  }

  .icon-center {
    i {
      margin-top: 8px;

      &:hover {
        cursor: pointer;
      }
    }

    .icon-return {
      transform: rotate(180deg);
    }
  }

  .no-add {
    display: flex;
    justify-content: space-between;
    height: 35px;
    line-height: 35px;
    line-height: 35px;
    font-size: 14px;
    margin-bottom: 10px;
    // background: #F5F7FA;

    span {
      color: #333;
      font-size: 18px;
      margin-left: 20px;
    }
  }
}

.el-transfer-panel__filter {
  width: 100%;
  height: 32px;
  font-size: 12px;
  display: inline-block;
  box-sizing: border-box;
  border-radius: 16px;
  padding-right: 10px;
  margin: 0;
}

.table-footer {
  width: 100%;
  height: 40px;
  border: 1px solid #EBEEF5;
}

.handle-btn {
  margin: 5px 0 0 -75%;
}

.search-position {
  line-height: 33px;
  margin-left: 12px;
}

.order-dialog {
  /deep/ .el-dialog {
    border-radius: 12px;
    overflow: visible;
  }

  /deep/ .el-dialog__body {
    overflow: visible;
  }

  /deep/ input {
    width: 380px;
  }
  /deep/ .order-cascader-popper {
    z-index: 3000 !important;
  }
}
</style>



// WEBPACK FOOTER //
// inviteDesigner.vue?96bdcbd0